import lottie from 'lottie-web'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { createPulseMark } from './pulse-mark.js'

let homeBannerAnimation
let heroMarkAnimation

export const homeBanner = () => {
	lottieSetup()
	heroMark()
	parallax()
}

const heroMark = () => {

	if (heroMarkAnimation) {
		heroMarkAnimation.destroy()
		heroMarkAnimation = null
	}

	const container = document.querySelector('[data-lottie="hero-mark"]')

	if (!container) return

	heroMarkAnimation = createPulseMark(container, {
		onReady: () => { container.dataset.markStatus = 'animated' },
		onFail: () => {
			heroMarkAnimation = null
			container.removeAttribute('data-mark-status')
		},
	})

	if (!heroMarkAnimation) return

	ScrollTrigger.create({
		trigger: container.closest('.banner-home') || container,
		start: 'top bottom',
		end: 'bottom top',
		onToggle: self => {
			if (!heroMarkAnimation) return
			self.isActive ? heroMarkAnimation.play() : heroMarkAnimation.pause()
		},
	})
}

export const lottieSetup = () => {

	let el = document.querySelector('[data-lottie="homepage-heading"]')

	if (!el || window.innerWidth < 782) return

	homeBannerAnimation = lottie.loadAnimation({
		container: el,
		renderer: 'svg',
		loop: false,
		autoplay: false,
		path: '/json/bannere.json'
	})

	/*
	homeBannerAnimation.addEventListener('DOMLoaded', () => {
		let tries = 0;
		const interval = setInterval(() => {
			console.log(tries)
			const labels = el.querySelectorAll('[aria-label]');
			if (labels.length) {
				labels.forEach(label => label.removeAttribute('aria-label'));
				console.log('Removed aria-labels');
			}
			if (++tries > 50) clearInterval(interval);
		}, 100);
	})
	*/
}

const parallax = () => {

	let el = document.querySelector('[data-animation="home-banner-parallax"]')

	if (!el) return

	gsap.fromTo(el, {
		yPercent: 0,
		opacity: 1,
	}, {
		yPercent: 20,
		opacity: 0.4,
		scrollTrigger: {
			trigger: el.parentElement,
			start: 'top top',
			end: 'bottom top',
			scrub: true,
			// markers: true,
		}
	})
}

export const homeBannerPlay = () => {
	if (homeBannerAnimation && window.innerWidth > 782) {
		homeBannerAnimation.goToAndPlay(0, true)
		homeBannerAnimation.addEventListener('complete', () => {
			homeBannerAnimation.playSegments([140, 174], true)
		})
	}
}

export default () => { }